export default "__VITE_ASSET__Dbp42C0t__"